import { ClipboardList, Cpu, Gauge, Sparkles } from "lucide-react";

const steps = [
  {
    icon: ClipboardList,
    number: "01",
    title: "Answer a few questions",
    desc: "Share your health and lifestyle information through a simple, guided flow.",
  },
  {
    icon: Cpu,
    number: "02",
    title: "AI analyzes your data",
    desc: "Our models examine hundreds of subtle patterns across your inputs securely.",
  },
  {
    icon: Gauge,
    number: "03",
    title: "Personalized Health Risk Score",
    desc: "Get a clear, easy-to-understand score reflecting your current wellness.",
  },
  {
    icon: Sparkles,
    number: "04",
    title: "Actionable recommendations",
    desc: "Receive suggestions to encourage healthier lifestyle choices — and when to seek professional guidance.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 grid-radial opacity-60 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-400">
            Process / 02
          </p>
          <h2 className="font-display mt-4 text-4xl sm:text-5xl font-semibold tracking-tight">
            How It Works
          </h2>
          <p className="mt-5 text-lg text-zinc-400 max-w-2xl">
            From questions to insights in four simple steps. Designed to feel effortless.
          </p>
        </div>

        <div className="mt-16 relative">
          {/* Glowing connecting line (desktop) */}
          <div className="hidden lg:block absolute top-10 left-[8%] right-[8%] h-px bg-gradient-to-r from-transparent via-cyan-400/50 to-transparent" />

          <div className="grid lg:grid-cols-4 gap-6 lg:gap-8">
            {steps.map((step, i) => (
              <div
                key={step.number}
                data-testid={`step-${i + 1}`}
                className="relative group"
              >
                {/* Icon circle */}
                <div className="relative w-20 h-20 mx-auto lg:mx-0 rounded-full glass-card flex items-center justify-center transition-all duration-500 group-hover:border-cyan-400/50">
                  <div className="absolute inset-0 rounded-full bg-gradient-to-br from-cyan-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                  <step.icon className="w-8 h-8 text-cyan-400 relative z-10" strokeWidth={1.5} />
                  <span className="absolute -top-1 -right-1 w-7 h-7 rounded-full bg-[#0B3D91] border border-cyan-400/40 flex items-center justify-center text-[10px] font-bold text-cyan-100">
                    {step.number}
                  </span>
                </div>
                <div className="mt-6 text-center lg:text-left">
                  <h3 className="font-display text-xl font-semibold text-white tracking-tight">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-sm text-zinc-500 leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
